<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="repairPlanDetailResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" edit-disable
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                              <template #left-header>
                                <em-button type="delete"
                                           :disabled="actionDisabled('select')"
                                           v-bind:class="'btn btn-outline-primary btn-sm'"
                                           @click="removeFromPlan()"
                                >
                                </em-button>
                              </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author YuJiaBei
    // Date 2021-01-05 08:33:12

    import emCommonListMixin from "@/mixin/em/common/list";
    import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
    import commonViewsUtil from "@/utils/commonViewsUtil";
    import emApiMixin from "@/mixin/em/common/api";

    export default {
        name: "repairPlanDetailListView",
        mixins: [emCommonListMixin,emTableCheckedMixin,emApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
          planId(){
            return this.$store.state[this.modelName].filterHolder.rpdIdRplFilter
          }
        },
        methods:{
          removeFromPlan() {
            if (this.selectIds && this.planId) {
              let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/remove?detailIds=${this.selectIds}&planId=${this.planId}`
              this.$_emApiMixin_post(url, {})
                  .then(response => {
                    commonViewsUtil.showSuccess(this, "移除成功")
                    this.$refs.emListFilter.doQuery()
                  })
            }
          }
        }
    };
</script>